import { render, staticRenderFns } from "./SkuInfoItemTwo.vue?vue&type=template&id=333428cb&scoped=true"
import script from "./SkuInfoItemTwo.vue?vue&type=script&lang=js"
export * from "./SkuInfoItemTwo.vue?vue&type=script&lang=js"
import style0 from "./SkuInfoItemTwo.vue?vue&type=style&index=0&id=333428cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333428cb",
  null
  
)

export default component.exports